export class Length {
  private readonly value: number;

  constructor(lengthInMillimeters: number) {
    this.value = lengthInMillimeters;
  }

  inMillimeters(): number {
    return this.value;
  }

  inMeters(): number {
    return this.value / 1000;
  }

  public static fromMeters(lengthInMeters: number): Length {
    return new Length(lengthInMeters * 1000);
  }
}
